import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import mainAxios from "../redux/api/mainAxios";

const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [favoriteLots, setFavoritesLots] = useState([]);

  const userIdString = localStorage.getItem("user");
  const userId = JSON.parse(userIdString);
  const id = userId.id;

  const token = localStorage.getItem("token");

  const { user } = useSelector((state) => state.userAuthReducer);

  useEffect(() => {
    if (user) {
      setFavorites(user.programmes_favoris || []);
      setFavoritesLots(user.lots_favoris || []);
    }
  }, [user]);

  const isProgramInFavorites = (programmeId) => {
    return favorites.some((program) => program.documentId === programmeId);
  };

  const isLotInFavorites = (programmeId) => {
    return favoriteLots.some((program) => program.documentId === programmeId);
  };

  const handleAddToFavorites = async (programmeId, collectionType) => {
    try {
      const isFavorite = isProgramInFavorites(programmeId);
      const isLotFavorite = isLotInFavorites(programmeId);

      const updatedFavorites = isFavorite
        ? favorites.filter((program) => program.documentId !== programmeId)
        : [...favorites, { documentId: programmeId }];
      const updatedLotFavorites = isLotFavorite
        ? favoriteLots.filter((program) => program.documentId !== programmeId)
        : [...favoriteLots, { documentId: programmeId }];

      await mainAxios.post(`api/user/toggleFavorite`, {
        documentId: programmeId,
        collectionType: collectionType,
      });

      setFavorites(updatedFavorites);
      setFavoritesLots(updatedLotFavorites);

      toast.success(
        isFavorite
          ? `${collectionType} retiré des favoris.`
          : `${collectionType} ajouté aux favoris.`
      );
    } catch (error) {
      console.error("Error toggling program in favorites:", error);
    }
  };

  return {
    favorites,
    isProgramInFavorites,
    handleAddToFavorites,
    isLotInFavorites,
  };
};

export default useFavorites;
